<template>
	<div class="film-list my-40">
		<!--  film-list 标题  -->
		<div class="text-xl weight gray text-left">{{film_title}}</div>
		<div v-for="(film,index) of film_list"
			:key="film.filmId"
			@click="film_click (film.filmId)">
			<!--  film-list 第一部影片  -->
			<div class="flex item-center hand my-10 px-10 py-10 hover-box-shadow rounded"
				v-show="index==0">
				<div class="film-list-img rounded">
					<img :src="'http://124.222.209.62/atstudy-cateye/imgs/film_avat/'+film.filmAvat" class="w-100"/>
				</div>
				<div class="ml-20">
					<div class="text-lg dark text-left my-10">{{film.filmName}}</div>
					<div v-if="type=='1'" class="text-md bold red text-left my-10">{{film.filmTotalcost}}万</div>
					<div v-if="type=='2'" class="text-md bold red text-left my-10">{{film.filmFavorite}}人想看</div>
					<div v-if="type=='3'" class="text-md bold red text-left my-10">{{film.filmPraise}}分</div>
				</div>
			</div>
			<!--  film-list 非第一部影片  -->
			<div class="flex justify-between item-center hand px-10 py-5 hover-box-shadow rounded"
				v-show="index!=0">
				<div class="flex item-center">
					<div class="text-xl red bold">{{index+1}}</div>
					<div class="text-lg dark text-left ml-10">{{film.filmName}}</div>
				</div>
				<div v-if="type=='1'" class="text-md bold red text-left my-10">{{film.filmTotalcost}}万</div>
				<div v-if="type=='2'" class="text-md bold red text-left my-10">{{film.filmFavorite}}人想看</div>
				<div v-if="type=='3'" class="text-md bold red text-left my-10">{{film.filmPraise}}分</div>
			</div>
		</div>
	</div>
</template>

<script>
	
	export default {
		methods:{
			film_click (filmId) {
				this.$router.push({
					path: `/film/${filmId}`
				})
			}
		},
		props: ['film_list', 'film_title', 'type']
	}
</script>

<style>
</style>
